import { render, staticRenderFns } from "./sportClubBoardTypeForm.vue?vue&type=template&id=53393f30&"
import script from "./sportClubBoardTypeForm.vue?vue&type=script&lang=js&"
export * from "./sportClubBoardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports